export default __webpack_public_path__ + "static/media/RPMImg.918814f3.svg";